import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'

export default function BrandsCarousel() {
    const carouselImages = [
        { title: 'Best ever show', url: 'best-ever-show.svg' },
        { title: 'Bigger pockets', url: 'bigger-pockets.svg' },
        { title: 'Joe Homebuyer', url: 'joe-homebuyer.svg' },
        { title: 'Kentucky sell now', url: 'kentucky-sell-now.svg' },
        { title: 'Real estate disruptors', url: 'real-estate-disruptors.svg' },
        { title: 'The real dealz', url: 'the-real-dealz.svg' },
        {
            title: 'The real estate invest her',
            url: 'the-real-estate-invest-her.svg',
        },
        { title: 'TTP', url: 'ttp.svg' },
    ]

    const settings = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 10,
        centerMode: true,
        className: 'slider variable-width',
        dots: false,
        easing: 'linear(0, 1)',
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 2000,
        variableWidth: true,
    }
    return (
        <div className="xl:px-0 m-auto my-16 max-w-full w-[1200px] px-6 text-center">
            <p className="text-base md:leading-7 leading-[25px] tracking-wider font-bold py-8 uppercase">
                We work with thousands of REAL ESTATE Investors and Agents
            </p>
            <div className="partners-carousel relative">
                <Slider {...settings}>
                    {carouselImages.map((image, index) => (
                        <div className="mx-4" key={index}>
                            <img
                                className="inline-block h-full"
                                src={`/assets/partner-brands/${image.url}`}
                                alt={image.title}
                            />
                        </div>
                    ))}
                </Slider>
                <div className="md:w-[200px] w-[100px] bg-gradient-to-r from-white to-transparent h-full absolute top-0 left-0"></div>
                <div className="md:w-[200px] w-[100px] bg-gradient-to-l from-white to-transparent h-full absolute top-0 right-0"></div>
            </div>
        </div>
    )
}
